import { render, staticRenderFns } from "./LiveBanner.vue?vue&type=template&id=4476a05d&scoped=true&"
import script from "./LiveBanner.vue?vue&type=script&lang=js&"
export * from "./LiveBanner.vue?vue&type=script&lang=js&"
import style0 from "./LiveBanner.vue?vue&type=style&index=0&id=4476a05d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476a05d",
  null
  
)

export default component.exports